import * as React from 'react';
import '../css/rap.sass';
import Popup from './Popup';

interface RAPPopupProps {
  children: React.ReactNode;
  toggleRAP: boolean;
  onClose?: Function;
}

interface RAPPopupState {
  visible?: boolean;
}
export default function RAPPopup(props: RAPPopupProps) {
  const [state, setState] = React.useState<RAPPopupState>({
    visible: props.toggleRAP
  });

  return (
    <>
      {state.visible ? (
        <div className="mobileRAPSection">
          <Popup
            onClose={() => {
              setState({ ...state, visible: false });
              if (props.onClose !== undefined) {
                props.onClose();
              }
            }}
            modal
            position="center"
            displayCloseButton
          >
            {' '}
            <div className={`rap ${state.visible ? 'slideUp' : 'slideDown'} `}>
              {props.children}
            </div>
          </Popup>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
